import Backtest from "../js/components/coreServices/Backtest.react";
export default Backtest;
